const discovered = [];

export default class Piwik {
    _tracker;
    _trackIndex;

    /**
     * @param {*} tracker - The piwik tracker object
     * @param {number} trackIndex - The trackIndex the tracker should start with
     */
    constructor(tracker, trackIndex = -1) {
        this._tracker = tracker;
        this._trackIndex = trackIndex;
    }

    get trackIndex() {
        return this._trackIndex;
    }

    /**
     * track an url or event
     * @param {string} type - The type of track
     * @param {*} payload - The tracking payload
     * @param {number} trackIndex - The index of the track event
     * @returns {Promise} - resolves when it is ok to continue tracking
     */
    track(type, payload, trackIndex) {
        this._trackIndex = trackIndex;
        if (type === 'event') {
            return this._trackEvent(
                payload.category, 
                payload.action, 
                payload.label, 
                payload.value, 
            );
        } else if(type === 'page') {
            return this._trackPage(payload.url, payload.title);
        }
    }

    /**
     * track an url
     * @param {string} url - The url of the page
     * @param {string} title - The title of the page
     * @returns {Promise} - resolves when it is ok to continue tracking
     */
    _trackPage(url, title) {
        this._tracker.setCustomUrl(url);
        this._tracker.trackPageView(title);
        return Promise.resolve(true);
    }

    /**
     * track an even
     * @param {string} category - The category or type of event 
     * @param {string} action - The type of interaction that triggered the event
     * @param {string} label - An additional label for the event
     * @param {number} value - A numeric value associated with the event
     * @returns {Promise} - resolves when it is ok to continue tracking
     */
    _trackEvent(category, action, label, value) {
        this._tracker.trackEvent(category, action, label, value);
        return Promise.resolve(true);
    }

    /**
     * destroy the tracker instance and clean up if necessary
     */
    destroy() {
        discovered.splice(discovered.indexOf(this._tracker.getTrackerUrl()), 1);
    }

    /**
     * repeat calls to this function will not discover the same tracker again
     * @param {number} trackIndex - The trackIndex the tracker should start with
     * @returns - A promise resolving an array of wrapper instances for discovered tracker
     */
    static discover(trackIndex = -1) {
        return new Promise((resolve, reject) => {
            const paq = '_paq';
            if (window[paq]) {
                window[paq].push([() => {
                    resolve(window.Piwik.getAsyncTrackers().map(tracker => {
                        const trackingId = tracker.getTrackerUrl();
                        if (~discovered.indexOf(trackingId)) { return null; }
                        discovered.push(trackingId);
                        return new Piwik(tracker, trackIndex);
                    }).filter(Boolean))
                }]);
            } else {
                resolve([])
            }
        });
    }

    /**
     * initialize general purpose things like the tracker's library js
     */
    static init() {
        return Promise.resolve();
    }

    /**
     * @param {*} options - The tracker options 
     * @returns - A promise resolving the wrapper instance
     */
    static create({}) {
        return new Promise((resolve, reject) => {
            //TODO
        })
    }
}


// WEBPACK FOOTER //
// ./lib/analytics/tracker-piwik.js